





























































































































import Vue from 'vue'
import Icon from '@/components/globals/Icon.vue'
import { FacilityId, Facility, buildFacilityPath } from '@/core/Facilities'
import Stars from '@/components/globals/basics/Rating/Stars.vue'
import FavoriteButton from '@/components/globals/basics/Favorite/FavoriteButton.vue'
import Button from '@/components/globals/Button.vue'
import DimensionMeasurer from '@/components/globals/DimensionMeasurer.vue'
import { Program } from '@/core/Programs'
import FacilityPrograms from './FacilityPrograms.vue'
import Loading from '@/components/globals/basics/Loading/Loading.vue'

export default Vue.extend({
  name: 'FacilityCardWithPrograms',
  filters: {
    formatScore(score: number) {
      const floatValue = score - Math.floor(score)
      // 小数点以下がない場合は.0をsuffixする
      return floatValue === 0 ? `${score}.0` : score
    },
  },
  components: {
    Icon,
    Stars,
    Button,
    DimensionMeasurer,
    FavoriteButton,
    FacilityPrograms,
    Loading,
  },
  props: {
    component: {
      type: String,
      default: 'div',
    },
    facility: {
      type: Object as () => Facility,
      required: true,
    },
    isFavorited: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowMorePrograms: false,
      loadedPrograms: [] as Program[],
      programsHeight: 0,
      measurer: null as Function | null,
    }
  },
  computed: {
    programs(): Program[] {
      const [first, second, third] = this.facility.programs
      return this.isShowMorePrograms
        ? this.facility.programs
        : [first, second, third].filter((p) => p)
    },
    normalFacilityPath(): string {
      return buildFacilityPath(this.facility)
    },
    facilityPath(): string {
      return !this.facility.isOnline
        ? this.normalFacilityPath
        : `/online_facilities/${this.facility.id}`
    },
  },
  methods: {
    handleFavoriteClick(facilityId: FacilityId, favorited: boolean) {
      this.$emit('onFavorited', facilityId, favorited)
    },
    handleProgramsMeasurerReady(measurer: Function) {
      this.measurer = measurer
      this.updateProgramsHeight()
    },
    updateProgramsHeight() {
      if (!this.measurer) return
      const height = this.measurer().height

      if (this.programsHeight === height) return

      this.programsHeight = height
    },
    toggleShowMorePrograms() {
      this.isShowMorePrograms = !this.isShowMorePrograms
      setTimeout(() => {
        this.updateProgramsHeight()
      }, 0)
    },
  },
})
